// extracted by mini-css-extract-plugin
module.exports = {"form":"ContactForm-module--form--1_Jqz","formRow":"ContactForm-module--formRow--10HXC","formCol":"ContactForm-module--formCol--FdL1I","button":"ContactForm-module--button--108Oe"};